import script from "./Detail.vue?vue&type=script&lang=ts&name=QuestionDetail&setup=true"
export * from "./Detail.vue?vue&type=script&lang=ts&name=QuestionDetail&setup=true"

import "./Detail.vue?vue&type=style&index=0&id=3049985b&scoped=true&lang=css"

import exportComponent from "/Users/niming/Documents/vue-mooc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3049985b"]])

export default __exports__